import { BarChartSquare02 } from "@untitledui/icons";
import { cx } from "@/utils/cx";

/**
 * Loading state for the Weekly KPIs Overview section
 */
export const WeeklyKPIsLoadingState: React.FC = () => {
  return (
    <div className={cx("w-full", "inline-flex gap-12 items-end")}>
      <div className="w-11/40 self-stretch inline-flex flex-col justify-start items-start">
        <div className="self-stretch flex-1 grid items-center text-primary text-3xl font-normal leading-[38px] px-2">
          Core Performance Metrics
        </div>
      </div>
      <div className="w-29/40 flex justify-start items-start gap-4">
        <div className="flex-1 h-[320px] animate-pulse rounded-lg bg-gray-200" />
        <div className="flex-1 h-[320px] animate-pulse rounded-lg bg-gray-200" />
        <div className="flex-1 h-[320px] animate-pulse rounded-lg bg-gray-200" />
      </div>
    </div>
  );
};

interface ChartWithCardsLoadingStateProps {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
}

/**
 * Loading state for overview sections with a large chart and two smaller card metrics
 * Used by RevenueOverview and CreatorsOverview
 */
export const ChartWithCardsLoadingState: React.FC<ChartWithCardsLoadingStateProps> = ({ title, icon: Icon }) => {
  return (
    <div
      className={cx(
        "w-full  px-8 py-6", // Min Max stretch width
        "bg-white rounded-lg", // Container aesthetic
        "justify-between items-start inline-flex flex-col gap-6", // Internal stretch behaviour
      )}
    >
      <div className="inline-flex justify-start items-center gap-2">
        <Icon className="w-5 h-5 text-primary" />
        <div className="text-primary text-base font-medium">{title}</div>
      </div>
      <div className="self-stretch inline-flex justify-start items-center gap-4">
        <div className="flex-1 h-80 animate-pulse rounded-lg bg-gray-200" />
        <div className="w-[388px] flex flex-col gap-4">
          <div className="h-36 animate-pulse rounded-lg bg-gray-200" />
          <div className="h-36 animate-pulse rounded-lg bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

/**
 * Loading state for RevenueOverview section
 */
export const RevenueLoadingState: React.FC = () => (
  <ChartWithCardsLoadingState title="Revenue" icon={BarChartSquare02} />
);

/**
 * Loading state for CreatorsOverview section
 */
export const CreatorsLoadingState: React.FC = () => (
  <ChartWithCardsLoadingState title="Creators" icon={BarChartSquare02} />
);
